import React, { useState, useEffect, useRef } from "react";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import axios from "axios";
import BasicCard from "../BasicCard";
import Dummylayout from "../Dummylayout";
import Modal from "react-bootstrap/Modal";
import { useSearchParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Button from "react-bootstrap/Button";

import * as ReactBootstrap from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";

import { Toast, ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../../config";

function calculateTotalMarks(marks) {
  if (!marks || marks.length === 0) return 0; // If marks is undefined or empty, return 0
  if (marks.length === 1) return parseInt(marks[0], 10);

  return marks.reduce(
    (total, mark) => total + (mark ? parseInt(mark, 10) : 0),
    0
  );
}
const getProgressColor = (progress) => {
  if (progress <= 30) {
    return "danger";
  } else if (progress <= 60) {
    return "warning";
  } else {
    return "success";
  }
};

const role = localStorage.getItem("userrole");
function ViewMyAppraisal() {
  const [employee, setEmployee] = useState([]);
  const [options, setOptions] = useState([]);
  const [options2, setOptions2] = useState([]);
  const [subcat, setSubcat] = useState([]);
  const [grade, setGrade] = useState([]);
  const [categoryMapvalues, setCategoryMapvalues] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModal2Open, setIsModal2Open] = useState(false);
  const [approval, setApproval] = useState(null);
  const [appeal, setAppeal] = useState(null);
  const [approvalDate, setApprovalDate] = useState(null);
  const [appeallDate, setAppeallDate] = useState(null);
  const [approvalStatus, setApprovalStatus] = useState(null);
  const [employeeComments, setEmployeeComments] = useState(null);
  const [employeeApprovalDate, setEmployeeApprovalDate] = useState(null);
  const [sectionTotal, setSectionTotal] = useState(null);
  const [attsubtotal, setAttSubtotal] = useState(0);
  const [showToast, setShowToast] = useState(false);
  const navigate = useNavigate();
  const usernameRef = useRef(null);
  const [categorySubtotal, setCaegorytSubtotal] = useState(0);
  const [primaryCategoryName, setPrimaryCategoryName] = useState("");
  // const [formData, setFormData] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [showLabel, setShowLabel] = useState(false);
  const [attendanceOptions, setAttendanceOptions] = useState(false);
  const [performanceeOptions, setPerformanceOptions] = useState(false);
  const [categoryOptions, setCategoryOptions] = useState(false);
  const [attendan, setAttendance] = useState(false);
  const [performanceeAnswers, setPerformanceAnswers] = useState(false);
  const [attendanceAnswers, setAttendanceAnswers] = useState(false);
  const [managerName, setManagerName] = useState(false);
  const [supervisorName, setSupervisorName] = useState(false);
  const [hassupervisor, setHasSupervisor] = useState("no");
  const [kpiOptions, setKPIOptions] = useState(false);
  const [kpiTotal, setKPITotal] = useState(0);
  const [totVal, setTotVal] = useState(0);
  const [cattotal, setCatTotal] = useState(null);
  const [subkpiOptions, setSubKPIOptions] = useState(false);
  const [trainingComment, setTrainingComment] = useState(null);

  const [managerComments, setManagerComments] = useState(null);
  const [approverComments, setApproverComments] = useState(null);
  const [smartKPITotal, setSmartKPITotal] = useState(0);
  const [subKPITotal, setSubKPITotal] = useState(0);
  const [atotal, setAtotal] = useState(null);
  const [ptotal, setPtotal] = useState(null);
  const [total, setTotal] = useState(null);
  // ▶ URLSearchParams {}
  const userid = localStorage.getItem("userid");
  const [posts, setPosts] = useState({ smartgoals: [] });
  const [expandedRow, setExpandedRow] = useState(null);
  const [postsSub, setPostsSub] = useState({ subgoals: [] });
  const [isKpiWeightageIncluded, setIsKpiWeightageIncluded] = useState(false);
  const [KPIWeightage, setKPIWeightage] = useState(0);
  const [apprQuestionsWeightage, setApprQuestionsWeightage] = useState(0);
  let deptid = localStorage.getItem("departmentid");
  let currentuserid = localStorage.getItem("employeeid");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [appealStatus, setAppealStatus] = useState(null);
  const [showHRApproval, setShowHRApproval] = useState(null);
  const [hrApproved, setHRApproved] = useState(false);
  const [hrComments, setHRComments] = useState(null);
  const [apraisalid, setAppraiaisalId] = useState(null);
  const [datemanagerapproved, setDateManagerApproved] = useState(null);
  const [approvalcomments, setApprovalComments] = useState(null);
  const [rating, setRating] = useState(null);
  const [approversComments, setApproversComments] = useState(null);
  const [assessorComments, setAssessorComments] = useState(null);
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [assessorDate, setAssessorDate] = useState(null);
  const [approversDate, setApproversDate] = useState(null);
  const id = localStorage.getItem("employeeid");
  const action = searchParams.get("action");
  const appraisalid = searchParams.get("aid");
  const [perfmarks, setPefMarks] = useState(null);
  const [catSubtotal, setCatSubtotal] = useState(null);
  const [catMarks, setCatMarks] = useState(
    Array(categoryMapvalues?.length).fill("")
  );
  const [categorymarks, setCategorymarks] = useState({});
  const [catSubcatMarks, setCatSubcatMarks] = useState({});
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedPeriod, setSelectedPeriod] = useState("April");
  const [employeeStatus, setEmployeeStatus] = useState("");
  const nextYear = currentYear + 1;
  let selyear = nextYear;
  const appraisalmonth = selectedPeriod;
  const appraisalyear = currentYear;
  // let showAppraisal = false;
  const [showAppraisal, setShowAppraisal] = useState(false);
  const [period, setPeriod] = useState("");

  const handleYearChange = (event) => {
    let yr = event.target.value;

    setSelectedYear(yr);
    setSelectedPeriod("April");
  };
  const handlePeriodChange = async (event) => {
    let pd = event.target.value;

    setSelectedPeriod(pd);
  };
  const [initialValues, setInitialValues] = useState({
    questions: [],
    questionsp: [],
  });

  const [generalComments, setGeneralComment] = useState(null);
  const role = localStorage.getItem("userrole");
  const [form2Data, setForm2Data] = useState({
    appealcomments: "",
    userid: id,
    // Add other fields here
  });
  const input = period;
  const match = input?.match(/([A-Za-z]+)(\d+)/);
  const month = match?.[1];
  const year = match?.[2];

  const handleAppealChange = (event) => {
    const { name, value } = event.target;
    setForm2Data({
      ...form2Data,
      [name]: value,
    });
  };

  const calculateSectionTotals = (perfOptions) => {
    let initialMarks = [];

    let index = 0;
    let opt = "";
    for (let i = 0; i < perfOptions.length; i++)
      initialMarks[i] = perfOptions[i].rating;

    setPefMarks(initialMarks);
    let total = perfOptions.reduce((total, option) => {
      return total + parseInt(option.rating, 10);
    }, 0);
    console.log("subtotal=" + total);
    setSectionTotal(total);
  };

  const handleHRApproval = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/hrapproval?id=` +
          id +
          "&aid=" +
          appraisalid +
          "&c=" +
          hrComments
      );
      const data = response.data;
      if (response.status === 200) {
        setHRApproved(true);
        setApprovalStatus("HR Approved");
      } else {
        console.error("Form submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };
  const addNotification = async (id) => {
    try {
      const response = await axios.get(
        `${baseURL}/addnotification?id=` + userid
      );
      const data = response.data;
      if (response.status === 200) {
      } else {
        console.error("Form submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const handleConfirmAppeal = async () => {
    try {
      const response = await axios.post(
        `${baseURL}/appealrequest?period=${period}`,
        {
          // Add your form value here
          aid: apraisalid,
          // Include other form data if needed
          ...form2Data,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status) {
        // setFormData(null);
        setIsModalOpen(false);

        setShowToast(true);
        // Redirect to the desired page

        setTimeout(() => {
          setShowToast(false);
          navigate("/dashboard");
        }, 3000);
      } else {
        console.error("Form submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const handleSubmit = async (values) => {
    setIsModalOpen(true);
    const formData = {
      employeeid: values?.employeeid,
    };

    setForm2Data(formData);
  };

  const formatDate = (dateString) => {
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", options);
  };

  const handleHEmployeeomments = (e) => {
    let val = e.target.value;
    setEmployeeComments(val);
  };
  const handleApproveromments = (e) => {
    let val = e.target.value;
    setApproverComments(val);
  };
  const handleApproverSubmit = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/addapprovercomments?id=` +
          id +
          "&aid=" +
          apraisalid +
          "&cmt=" +
          approverComments
      );
      const data = response.data;
      alert("Approver approval submitted");
      window.location.href = "/myteamappraisal";
    } catch (err) {
      console.error("Error :", err);
    }
  };
  const fetchAppraisalTemplate = async (gradeid) => {
    try {
      const response = await axios.get(
        `${baseURL}/gettemplateforappraisa?id=` + gradeid
      );
      const data = response.data;
      if (data && Array.isArray(data.template)) {
        const { data } = response; // make sure we can get data
        let toJSON = data?.template[0]?.questionsJSON;

        let finaljson = JSON?.parse(toJSON);

        // setOptions(finaljson.questions);
        setApprQuestionsWeightage(finaljson?.questionsweigtage);
        let kpi = finaljson?.isKpiWeightageIncluded;

        if (kpi) {
          let kpival = finaljson?.kpiweightage;
          setKPIWeightage(kpival);
          setIsKpiWeightageIncluded(kpi);
        } else {
          setIsKpiWeightageIncluded(false);
        }

        // const category44Options = finaljson.questions.filter(option => option.category === "44");
        // setAttendanceOptions(category44Options);
        // const categoryName = category44Options.length > 0 ? category44Options[0].categoryname : null; // Get category name if available
        // setPrimaryCategoryName(categoryName);
        // const category45Options = finaljson.questions.filter(option => option.category === "45");
        // setPerformanceOptions(category45Options);
        // setTotalQuestions(category44Options.length);

        //const categoryMap = new Map();
        // finaljson.questions.forEach((option) => {
        //     if (!categoryMap.has(option.category)) {
        //         categoryMap.set(option.category, []);
        //     }
        //     categoryMap.get(option.category).push(option);
        // });
        //   setCategoryMapvalues(categoryOtherOptions);
        // console.log(categoryOtherOptions);
        // setSubcat(finaljson[0].subCategoryQuestions);
        //calculateSectionTotals(category45Options);
        const groupedOptions = {};
        finaljson?.questions?.forEach((option) => {
          const categoryName = option?.category;
          // if((categoryName!=="44" && categoryName!=="45"))
          if (!groupedOptions?.[categoryName]) {
            groupedOptions[categoryName] = [option];
          } else {
            groupedOptions[categoryName]?.push(option);
          }
        });
        setCategoryMapvalues(groupedOptions);
        //const category44Options = finaljson.questions.filter(option => option.category === "44");
        // setAttendanceOptions(category44Options);
        // const category45Options = finaljson.questions.filter(option => option.category === "45");
        // setPerformanceOptions(category45Options);
        // const categoryOtherOptions = finaljson.questions.filter(option => option.category !== "44" && option.category !== "45");

        //const categoryMap = new Map();
        //  finaljson.questions.forEach((option) => {
        // if (!categoryMap.has(option.category)) {
        //    categoryMap.set(option.category, []);
        // }
        //  categoryMap.get(option.category).push(option);
        // });
        //   setCategoryMapvalues(categoryOtherOptions);
        // console.log(categoryOtherOptions);
        // setSubcat(finaljson[0].subCategoryQuestions);
        // calculateSectionTotals(category45Options);
        // const groupedOptions = {};
        // finaljson.questions.forEach(option => {
        //     const categoryName = option.category;
        //     if((categoryName!=="44" && categoryName!=="45"))
        //         if (!groupedOptions[categoryName] ) {
        //             groupedOptions[categoryName] = [option];
        //         } else {
        //             groupedOptions[categoryName].push(option);
        //         }
        // });
        // setCategoryMapvalues(groupedOptions);
        // updateinitVals(groupedOptions)
      }
    } catch (err) {
      console.error("Error fetching team members:", err);
    }
  };
  useEffect(() => {
    const fetchAppealStatus = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getappealrequest?id=` + id
        );
        const data = response.data;
        let appeal = data.appealdata;

        let appealdate = appeal[0].appealdate;
        //
        let appealid = appeal[0].id;

        let appealstatus = appeal[0].status;
        if (appealdate != null) {
          const res = await axios.get(
            `${baseURL}/getappealcommmiteedecisoin?aid=` + appealid
          );
          let appealdataarr = res.data?.appealdecision;

          let appealdescision = appealdataarr[0]?.approval_status;

          let dateformated = formatDate(appealdate);
          setAppeallDate(dateformated);

          if (appealdescision != null) {
            setAppealStatus(appealdescision);
          } else {
            setAppealStatus("Appeal Comittee needs to process");
            setAppeal(appealstatus);
          }
        }
      } catch (err) {
        console.error("Error fetching appealdata:", err);
      }
    };
    fetchAppealStatus();
  }, []);
  const updateinitVals = (categoryOptions) => {
    let updatedInitialValues = { ...initialValues };

    categoryOptions.forEach((category) => {
      updatedInitialValues[`questions${category.categoryname}`] =
        category.questions.map((question, qIndex) => ({
          [`questions${category.categoryname}[${qIndex}].question`]:
            question.text || "",
          [`questions${category.categoryname}[${qIndex}].yesno`]: "",
          [`questions${category.categoryname}[${qIndex}].rating`]:
            question.rating || 0,
          [`questions${category.categoryname}[${qIndex}].marks`]: 0,
          [`questions${category.categoryname}[${qIndex}].comments`]: "",
        }));

      setInitialValues(updatedInitialValues);
    });
  };

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getemployeemaindetails?uid=` + id
        );
        const data = response.data;
        let arrEmployee = data.employee;
        setEmployee(arrEmployee[0]);
        let gradeid = arrEmployee[0].gradeid;
        setGrade(gradeid);
        // await getKPIForuser(arrEmployee[0].employeeid);
        getSubKPI(arrEmployee[0].employeeid);
        fetchAppraisalTemplate(gradeid);
        let issupervisorPreent = arrEmployee[0].has_supervisor;
        setHasSupervisor(arrEmployee[0].has_supervisor);
        if (issupervisorPreent == "Yes") {
          let supervisorsname =
            arrEmployee[0].SupervisorFirstName +
            " " +
            arrEmployee[0].SupervisorLastName;
          setSupervisorName(supervisorsname);
        }
        let managersname =
          arrEmployee[0].ManagerFirstName +
          " " +
          arrEmployee[0].ManagerLastName;
        setManagerName(managersname);
        //fetchAppraisalTemplate(gradeid);
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchEmployeeData();
  }, []);

  console.log(year, "year");
  console.log(month, "month");

  useEffect(() => {
    const fetchManagerComments = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getappraisalmanagercomments?apprid=` + appraisalid
        );
        const data = response.data;
        let commentsArr = data.generalcomments[0];
        let comment = commentsArr.comments;
        setGeneralComment(comment);
        //fetchAppraisalTemplate(gradeid);
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchManagerComments();
  }, []);
  useEffect(() => {
    const fetchEmployeeApprovaStatus = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getemployeerapproval?id=` + id
        );
        const data = response.data;
        if (response.status === 200) {
          let appr = data.appealdata[0];

          if (appr !== undefined) {
            setEmployeeComments(appr.comments);
            setEmployeeApprovalDate(appr.statusdate);
            setEmployeeStatus("Employee Accepted");
          }
        }
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchEmployeeApprovaStatus();
  }, []);
  useEffect(() => {
    const fetchEmployeeStatus = async () => {
      if (year && month) {
        try {
          const response = await axios.get(
            `${baseURL}/getEmpappraisalstatus?id=` +
              id +
              "&mon=" +
              month +
              "&year=" +
              year
          );
          const data = response.data;

          if (response.status === 200) {
            let appr = data.appraisaldata[0];

            if (appr !== undefined) {
              let status = appr.status;
              let comment = appr.comments;
              setGeneralComment(comment);

              let asssordate = formatDate(appr.statusdate);
              setAssessorComments(comment);
              setAssessorDate(asssordate);
              setShowAppraisal(true);

              // setGeneralComment(gencomment);
              let dateformated;
              setApproval(status);
              if (status === "HR Approved") {
                setHRApproved(true);
                setApprovalStatus(status);
                setHRComments(comment);
              }
              if (appr.statusdate != null) {
                let dateformated = formatDate(appr.statusdate);
                let approvalstatus = appr.status;
                setApprovalDate(dateformated);
                setApprovalStatus(approvalstatus);
                let approvalcomments = appr.comments;
                setApprovalComments(approvalcomments);
              }
            } else {
              setApproval("Not initiated");
              setApprovalStatus("Not initiated");
              setShowAppraisal(false);
            }
          }
        } catch (err) {
          console.error("Error fetching team members:", err);
        }
      }
    };
    fetchEmployeeStatus();
    fetchEmployeeAppraisal();
    //   fetchEmployeeAppraisal();
  }, [month,year]);

  const calculateCategorySubtotal = (values, categoryName) => {
    let sum = 0;
    Object.keys(values).forEach((key) => {
      if (key.startsWith(`questions${categoryName}`)) {
        let obj = values[key];
        let marks = parseFloat(obj[0].marks);
        if (marks) {
          sum += marks;
        }
      }
    });
    setCaegorytSubtotal(sum);
    return sum;
  };

  const calTotalMarks = (questions) => {
    let totalMarks = 0;
    questions.forEach((question) => {
      totalMarks += parseInt(question.marks || 0);
    });

    return totalMarks;
  };

  const handleConfirm = async () => {
    try {
      const status = "Employee Accepted";
      const appraisalid = apraisalid;

      const response = await axios.get(
        `${baseURL}/approvaeappraisal?id=` +
          id +
          "&status=" +
          status +
          "&appraisalid=" +
          appraisalid +
          "&ecomment=" +
          employeeComments +
          "&period=" +
          period,
        form2Data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        // setFormData(null);
        setIsModalOpen(false);
        addNotification();
        setShowToast(true);
        setTimeout(() => {
          setShowToast(false);
          navigate("/dashboard");
        }, 3000);

        // window.location.href = "/dashboard";
      } else {
        console.error("Form submission failed:", response.statusText);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const handleHRComments = (e) => {
    let val = e.target.value;
    setHRComments(val);
  };

  const handleTextareaChange = (e) => {
    let val = e.target.value;
    setTrainingComment(val);
  };
  const handleKPIChange = (e, smartgoalId) => {
    const newValue = parseInt(e.target.value, 10);
    if (isNaN(newValue)) return; // Handle invalid input gracefully
    const kpis = {
      id: smartgoalId,
      val: newValue,
    };

    setKPIOptions((prevKPIOptions) => {
      // Ensure prevKPIOptions is always an array
      const optionsArray = Array.isArray(prevKPIOptions) ? prevKPIOptions : [];

      const existingKPIIndex = optionsArray.findIndex(
        (kpi) => kpi.id === smartgoalId
      );

      if (existingKPIIndex !== -1) {
        // If it exists, update the existing KPI value
        const updatedKPIOptions = [...optionsArray];
        updatedKPIOptions[existingKPIIndex] = kpis;
        return updatedKPIOptions;
      } else {
        // If it doesn't exist, add the new KPI to the array
        return [...optionsArray, kpis];
      }
    });
  };
  const handleSubKPIChange = (e, subgoalId) => {
    const newValue = parseInt(e.target.value, 10);
    if (isNaN(newValue)) return; // Handle invalid input gracefully
    const kpis = {
      id: subgoalId,
      val: newValue,
    };

    setSubKPIOptions((prevKPIOptions) => {
      // Ensure prevKPIOptions is always an array
      const optionsArray = Array.isArray(prevKPIOptions) ? prevKPIOptions : [];

      const existingKPIIndex = optionsArray.findIndex(
        (kpi) => kpi.id === subgoalId
      );

      if (existingKPIIndex !== -1) {
        // If it exists, update the existing KPI value
        const updatedKPIOptions = [...optionsArray];
        updatedKPIOptions[existingKPIIndex] = kpis;
        return updatedKPIOptions;
      } else {
        // If it doesn't exist, add the new KPI to the array
        return [...optionsArray, kpis];
      }
    });
  };
  const getSubKPI = async (empid) => {
    try {
      const { data } = await axios(`${baseURL}/getsubgoals?eid=` + empid);
      if (Array.isArray(data.subgoals)) {
        setPostsSub({ subgoals: data.subgoals });
      } else {
        console.error("Data is not an array:", data);
      }
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };
  const getKPIForuser = async (empid) => {
    const did = localStorage.getItem("departmentid");
    try {
      //alert(empid);
      let strAPI =
        // await `${baseURL}/smartgoalsfordepartment?assignee=${empid}&did=${did}&period=${period}`;
        await `${baseURL}/getkpiforappraisalperiod?assignee=${empid}&mon=${month}&year=${year}`;
      const { data } = await axios.get(strAPI);

      await setPosts({ smartgoals: data?.smartgoals });
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };

  useEffect(() => {
    const fetchManagerApprovaStatus = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getmanagerapproval?id=` + id
        );
        const data = response.data;
        if (response.status === 200) {
          let appr = data.appealdata[0];
          if (appr !== undefined) {
            setManagerComments(appr.comments);
          }
        }
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchManagerApprovaStatus();
  }, []);
  useEffect(() => {
    const fetchHRApprovaStatus = async () => {
      try {
        const response = await axios.get(`${baseURL}/gethrapproval?id=` + id);
        const data = response.data;
        if (response.status === 200) {
          let appr = data.appealdata[0];
          if (appr !== undefined) {
            setHRApproved(true);
            setShowHRApproval(true);
            setHRComments(appr.comments);
          }
        }
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchHRApprovaStatus();
  }, []);
  useEffect(() => {
    const fetchAssessorStatus = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getassessorstatus?apprid=` + appraisalid
        );
        const data = response?.data;
        if (response?.status === 200) {
          let appr = data?.appdata?.[0];
          if (appr !== undefined) {
            setAssessorComments(appr?.comments);
            setAssessorDate(appr?.statusdate);
          }
        }
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchAssessorStatus();
  }, []);
  useEffect(() => {
    const fetchApproverStatus = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getapproverstatus?id=` + id
        );
        const data = response.data;
        if (response.status === 200) {
          let appr = data.appealdata[0];
          if (appr !== undefined) {
            setApproversComments(appr.comments);
            setApproversDate(appr.statusdate);
          }
        }
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchApproverStatus();
  }, []);
  const fetchEmployeeAppraisal = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/getmyappraisal?employeeid=` + id
      );
      const data = response?.data;
      let arrEmployee = data?.appraisaldata;
      let arrqns = arrEmployee[0]?.questions;
      let training = arrEmployee[0]?.trainingcomments;
      setPeriod(arrEmployee[0]?.period);
      setAppraiaisalId(arrEmployee[0]?.id);
      let finaljson = JSON?.parse(arrqns);
      const questionsArray = Object?.values(finaljson);

      setInitialValues(questionsArray?.[4], questionsArray?.[3]);
      // setAttendanceOptions(finaljson.questions);
      setTrainingComment(training);
      let catsums = calculateCategorySums(finaljson);
      let catssubcats = getCatSubcats(finaljson);
      setCategorymarks(catsums);
      setCatSubcatMarks(catssubcats);
      let totalSum = 0;
      Object.values(catsums)?.forEach((value) => {
        totalSum += parseFloat(value) || 0;
      });
      setTotVal(totalSum);

      //  let catTotals =  calTotalMarks(finaljson.questions);

      let sumkpi = setKPITotals(finaljson);
      setKPITotal(sumkpi);

      // setCatTotal(catTotals);
      let totalval = 0;
      // setTotal(finaljson?.totalmarks);
      //setCatTotal(finaljson?.totalmarks);
      //calculateCategorySubtotal(arrEmployee[0]);
      if (sumkpi) {
        totalval = parseInt(totalSum) + parseInt(sumkpi);
      } else {
        totalval = parseInt(totalval);
      }

      switch (true) {
        case totalval >= 95:
          setRating("5-Outstanding");
          break;
        case totalval >= 80:
          setRating("4-Excellent");
          break;
        case totalval >= 65:
          setRating("3-Good");
          break;
        case totalval >= 50:
          setRating("2-Satisfactory");
          break;
        default:
          setRating("1-Unsatisfactory");
      }
      if (action === "hr") {
        setShowHRApproval(true);
      } else {
        setShowHRApproval(false);
      }

      setKPIOptions(finaljson?.smarkkpi);
      setSubKPIOptions(finaljson?.subkpi);
      setKPITotals(finaljson);

      const currentFormattedDate = new Date();
      let dt = formatDate(currentFormattedDate);
      setDateManagerApproved(dt);
    } catch (err) {
      console.error("Error fetching team members:", err);
    }
  };

  const setKPITotals = (json) => {
    let kpiSum = 0;
    let subKpiSum = 0;
    try {
      kpiSum = json.smarkkpi.reduce((sum, kpi) => sum + (kpi.val || 0), 0);
    } catch (e) {
      //if top level kpi is not there in json
    }
    try {
      subKpiSum = json.subkpi.reduce((sum, kpi) => sum + (kpi.val || 0), 0);
    } catch (e) {
      //if sub  kpi is not there in json
    }
    setKPITotal(kpiSum + subKpiSum);
    return kpiSum + subKpiSum;
  };
  useEffect(() => {
    setInitialValues({
      questions: attendanceOptions,
      questionps: performanceeOptions,
    });
  }, [options]);
  useEffect(() => {
    const fetchAssessorStatus = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getassessorstatus?apprid=` + appraisalid
        );
        const data = response.data;
        if (response.status === 200) {
          let appr = data.appdata[0];
          if (appr !== undefined || appr != null) {
            setAssessorComments(appr.comments);
            setAssessorDate(appr.statusdate);
          }
        }
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchAssessorStatus();
  }, []);
  useEffect(() => {
    const fetchSupervisorApprovaStatus = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getsupervisorapproval?id=` + id
        );
        const data = response.data;
        if (response.status === 200) {
          let appr = data.appealdata[0];
          if (appr !== undefined) {
            setAssessorComments(appr.comments);
            setAssessorDate(appr.statusdate);
          }
        }
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchSupervisorApprovaStatus();
  }, []);
  const calculateCategorySums = (appriasailjson) => {
    const categorySum = {};

    // Iterate over each top-level key in the data object
    Object.keys(appriasailjson).forEach((key) => {
      const items = appriasailjson[key];

      // Only process if the item is an array (and contains question objects with "marks")
      if (Array.isArray(items)) {
        items.forEach((item) => {
          // Check if 'category' and 'marks' fields are present in the object
          if (item.category && item.marks) {
            const category = item.category;
            const marks = parseInt(item.marks, 10); // Convert to number if needed
            if (!isNaN(marks)) {
              // Add marks to the corresponding category
              categorySum[category] = (categorySum[category] || 0) + marks;
            }
          }
        });
      }
    });

    return categorySum;
  };
  const calcAllTotal = (values) => {
    let val =
      calculateTotalMarks(values.questionsp?.map((q) => q.marks)) +
      categorySubtotal;
    setTotVal(val);
  };

  const fetchEmployeeApprovalStatus = async (apprid) => {
    try {
      const response = await axios.get(
        `${baseURL}/getEmployeeApproval?apprid=` + apprid
      );
      const data = response.data;
      if (response.status == 200) {
        let appr = data.employeeomments[0];
        if (appr != undefined) {
          let status = appr.status;

          let dateformated;
          let comment = appr.comments;
          setEmployeeComments(comment);
        }
      }
    } catch (err) {
      console.error("Error fetching team members:", err);
    }
  };

  const getCatSubTotal = (catjson, categoryval) => {
    // Initialize sum to 0
    let sum = 0;

    // Ensure catjson is an array and iterate over it
    if (Array.isArray(catjson)) {
      catjson.forEach((item) => {
        // Check for category and marks in each item
        if (item.category && item.marks) {
          const category = item.category;
          const marks = parseInt(item.marks, 10); // Convert to a number

          // Add marks to sum if category matches categoryval
          if (!isNaN(marks) && category === categoryval) {
            sum += marks;
          }
        }
      });
    }

    return sum;
  };

  const getCatSubcats = (appraisalJson) => {
    const categoryDetails = [];

    // Iterate over each top-level key in the data object
    Object.keys(appraisalJson).forEach((key) => {
      const items = appraisalJson[key];

      // Only process if the item is an array (and contains question objects with "marks")
      if (Array.isArray(items)) {
        items.forEach((item) => {
          // Check if 'category' and 'marks' fields are present in the object
          if (item.category && item.marks) {
            const category = item.category;
            const question = item.question;
            const subcategory = item.subcategory || ""; // Use an empty string if no subcategory is present
            const marks = parseInt(item.marks, 10); // Convert to number if needed
            const comments = item.comments;
            if (!isNaN(marks)) {
              // Add object with category, subcategory, and marks to array
              categoryDetails.push({
                category,
                subcategory,
                question,
                marks,
                comments,
              });
            }
          }
        });
      }
    });

    return categoryDetails;
  };

  const getMarks = (
    categoryDetails,
    targetCategory,
    targetSubcategory,
    question
  ) => {
    // Find the matching item in categoryDetails
    const matchingItem = catSubcatMarks?.find(
      (item) =>
        item.category === targetCategory &&
        item.subcategory === targetSubcategory &&
        item.question === question
    );

    // Return the marks if a matching item is found; otherwise, return null or 0
    return matchingItem ? matchingItem.marks : null;
  };
  const getComments = (
    categoryDetails,
    targetCategory,
    targetSubcategory,
    question
  ) => {
    // Find the matching item in categoryDetails
    const matchingItem = catSubcatMarks?.find(
      (item) =>
        item.category === targetCategory &&
        item.subcategory === targetSubcategory &&
        item.question === question
    );

    // Return the marks if a matching item is found; otherwise, return null or 0
    return matchingItem ? matchingItem.comments : null;
  };

  useEffect(() => {
    if (period) {
      getKPIForuser(employee.employeeid);
    }
  }, [period]);

  if (showAppraisal)
    return (
      <>
        <Dummylayout />
        <BasicCard>
          <div className="container topmiller ">
            <div className="row ">
              <table style={{ "backgrond-color": "#ffffff" }}>
                {/* <tr>
                  <td className="col-md-1">
                    <label>Step1: Select Year:</label>
                    <select onChange={handleYearChange}>
                      <option>Select Year</option>
                      <option value={currentYear - 1}>{currentYear - 1}</option>
                      <option selected value={currentYear}>
                        {currentYear}
                      </option>
                      <option value={nextYear}>{nextYear}</option>
                    </select>{" "}
                    <label>Step2: Select Period:</label>
                    <select
                      value={selectedPeriod}
                      onChange={handlePeriodChange}
                    >
                      <option value="Select">Select Period</option>
                      <option selected value={"April"}>
                        {" "}
                        April-{selectedYear}
                      </option>
                      <option value={"December"}>
                        {" "}
                        December-{selectedYear}
                      </option>
                    </select>
                  </td>{" "}
                  <td className="col-md-1"></td>
                </tr> */}
              </table>
              <br />
              {/* <hr /> */}

              <input
                type="text"
                name=""
                value={period}
                id=""
                style={{ width: "auto", marginBottom: 5 }}
              />
              <h5>My Appraisal </h5>
              <br />
              <br />
              <div className="col-4 ">
                <span className="vfont fs-">Name</span>
                <p className="bfont fs-5 fw-bold">
                  {employee?.FirstName} {employee?.LastName}
                </p>
                <span className="vfont fs">Current Position</span>
                <p className="bfont fs-5 fw-bold">{employee?.designation}</p>
              </div>
              <div className="col-4 ">
                <span className="vfont fs">Employee ID</span>
                <p className="bfont fs-5 fw-bold"> {employee?.employeeid}</p>
                <span className="vfont fs">Grade</span>
                <p className="bfont fs-5 fw-bold">{employee?.gradename}</p>
              </div>
              <div className="col-lg-4 ">
                <img
                  className="float-end mx-5"
                  width="110"
                  alt=""
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAADlAAAA5QGP5Zs8AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAelQTFRF////JG2SQICAJ05iM1VVNXWAM3CFKUtRM3GCJkdRNHCBJkNNJ0BIMnCAM3GAMnCAJDtBNHKAM3GAIzU5IzY7M3GAM3GAKk1WIi8yM3GAISwwM3GAM3GAICgrHyYoHiIjIiUoFBQUFRUUFhUVFhYWFxYWGRkYHBoYHR0eHR4fHh4fHiEiHiEjHx8gIi8zIjE1IjI2Ix4bIyMlIzU6JCAdJCIgJDY8JyIfJ0VNKEZNKSksKSktKTg5LCciLSsnLychL2JvL2VyMGNvMGVzMGZzMGl2MWp4MWt5MWx6Mm17Mm99MyojMzM5M2BpM3B/M3GANXKAN3KAOGx4OjUvO3SAPXSAPjw2Pj45PmVqPz9HP2ZsQF9iQ0VMQ0VNRUVNRUVORkQ9RkZPR1BMSEhRSUlTSkpUU0EzVldfV1dfWU1AXEc3XE9CXn+AXoCAX2l1YGl2Y4KBZk48a1I/b4J+co2iepOVe3uBe5OVgI+Xh46BjGlPjrDHkm5SmXJVnr/Tn7/TocDUo73Npr/PqcPUqq61r4JgsINhsbK1tMjVxZ98xaOCyKF+0aaB1NbY1qmC2ZRk2qB126J23KJ24KyC4qN55Kh65Onu5Oru5qZ75rWV6qh37Kx+7eLc7qx8769/8bGB8vn+87KB9LOCwa3cagAAACF0Uk5TAAcIDQ8YGSwtL0lQfISXmL/ByNXV2uPu7/Lz8/X5/P7+cDzfRAAAAfxJREFUGBllwYk/FFEcAPDfDrsYZtYsu6wZx+t8uSrddEh3aX8Ula5NTCelSESlKBKr0uEs3l/azHvP7O7H9wtJPjVohE0zbARVH2wW0KPoieoBSKdoFqaxNAVS+EMonb+AUsgPnuwIclfuHSJbjl27jFwkGyR/BLkb+wm3/SZyET9wSgiFq0Q6cAa5kAIuDYVbRNh5iRxFQQNHwELhPnGdePNrlGy7iJwVAAAdpeuEbH3w6R9jnwk5iYIO4IuidJy8/MZcf/fuQCnqAxWltsdPmPTiaRtKKgRR6vs6yqS3X/pQCoKBUm/iO5N+JHpRMiCMUmuCeRKtKIXBxA0980ya78ENJpjoGWZsfXV1nbFh9JgQRk/LNFuam1ti0y3oCYOBSe0zzDHTjkkGBDFF/8Ly8kI/pgiCiile/3S8whQq+KIoxZqG1lYWF1fWhppiKEV9ADq6Th3eXV1jT/weG/szYddU7zlyGl06AAQsxLP7qCveNfvh42xXnDp2HTyHaAXAoWGslnId9uTU1KTdQbnaGGrgUkKNVKjvHBwfH+ysp0JjSAHOX0SFuu6H794/6q6jQpEfpNwyKjTbIyN2MxXKcsGTVUK5yrsDA/FKypVkQYrM/Crqanj2vIG6qvIzIV1OQTl13L5DHeUFObBZRl5hcWlFRWlxYV4GeP4Dm5L5s3KTpvYAAAAASUVORK5CYII="
                />
              </div>
            </div>
          </div>

          <h5>Appraisal Questions </h5>
          <h6>Appraisal Questions Weightage Value: {apprQuestionsWeightage}</h6>
          <div className="mt-4 my-n4">
            <h5 className="text-start pb-3 newtext">{primaryCategoryName} </h5>
          </div>

          <Formik initialValues={initialValues} onSubmit={handleSubmit}>
            {({
              handleSubmit,
              handleChange,
              values,
              touched,
              errors,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                {categoryMapvalues &&
                  Object?.entries(categoryMapvalues)?.map(
                    ([categoryName, categoryOptions], index) => (
                      <div key={index}>
                        <h4>
                          {categoryOptions[0]?.categoryname
                            ? categoryOptions[0]?.categoryname?.replace(
                                "&amp;",
                                "&"
                              )
                            : ""}
                        </h4>{" "}
                        {/* Display category name */}
                        <table
                          id={`example${index}`}
                          className="table table-striped w-100 mt-2"
                        >
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Sub-Category Name</th>
                              <th>Question</th>
                              <th>Max Rating</th>
                              <th>Marks</th>
                              <th>Comments</th>
                            </tr>
                          </thead>
                          <tbody>
                            {categoryOptions?.map((option, qIndex) => (
                              <tr key={qIndex}>
                                <td>{qIndex + 1}</td>
                                <td>{option?.subcategoryname}</td>
                                <td>
                                  <Field
                                    as="textarea"
                                    disabled
                                    style={{ border: "none" }}
                                    rows={3}
                                    cols={30}
                                    readOnly={true}
                                    name={`questions${categoryName}[${qIndex}].question`}
                                    value={option?.text || option?.question}
                                  />
                                </td>
                                <td>
                                  {option?.yesNo ? (
                                    <div>
                                      <Field
                                        as="select"
                                        name={`questions${categoryName}[${qIndex}].yesno`}
                                      >
                                        <option value="0">Select Yes/No</option>
                                        <option value="1">Yes</option>
                                        <option value="0">No</option>
                                      </Field>
                                      <Field
                                        type="hidden"
                                        name={`questions${categoryName}${qIndex}].rating`}
                                      />
                                    </div>
                                  ) : (
                                    ((
                                      <Field
                                        type="hidden"
                                        name={`questions${categoryName}[${qIndex}].yesno`}
                                      />
                                    ),
                                    (
                                      <Field
                                        type="text"
                                        className="w-25"
                                        disabled
                                        name={`questions${categoryName}[${qIndex}].rating`}
                                        value={option?.rating}
                                      />
                                    ))
                                  )}
                                  <Field
                                    type="hidden"
                                    name={`questions${categoryName}[${qIndex}].category`}
                                    value={option?.category}
                                  />
                                  <Field
                                    type="hidden"
                                    name={`questions${categoryName}[${qIndex}].ssubcategory`}
                                    value={option?.subcategory}
                                  />
                                </td>
                                <td>
                                  <Field
                                    type="number"
                                    className="w-50"
                                    disabled
                                    name={`questions${categoryName}[${qIndex}].marks`}
                                    value={getMarks(
                                      catSubcatMarks,
                                      categoryName,
                                      option?.subcategory,
                                      option?.text
                                    )}
                                    max={option?.rating}
                                  />
                                </td>
                                <td>
                                  <Field
                                    as="textarea"
                                    disabled
                                    name={`questions${categoryName}[${qIndex}].comments`}
                                    cols={33}
                                    value={getComments(
                                      catSubcatMarks,
                                      categoryName,
                                      option?.subcategory,
                                      option?.text
                                    )}
                                  />
                                </td>
                              </tr>
                            ))}
                            <td
                              colSpan="6"
                              className="text-end mx-1 text-dark fw-bold"
                            >
                              Section Total
                              <Field
                                type="number"
                                disabled
                                className="float-end mx-2"
                                name={`questions${categoryName}.total`}
                                value={categorymarks[categoryName]} // Calculated subtotal    //getCatSubTotal(categoryOptions,categoryName)
                                readOnly
                              />
                            </td>
                          </tbody>
                        </table>
                      </div>
                    )
                  )}
                <table width={"100%"}>
                  {" "}
                  <tbody>
                    <tr>
                      <td
                        colspan="12"
                        className="text-end mx-1 text-dark fw-bold"
                      >
                        {" "}
                        Total Marks
                        <Field
                          type="number"
                          disabled
                          className="float-end mx-2 "
                          name="total"
                          value={totVal}
                          readOnly={true}
                        />{" "}
                      </td>
                    </tr>

                    <tr>
                      <td
                        colspan="12"
                        className="text-start mx-1 text-dark fw-bold"
                      >
                        {/* 
-------------------------KPI Appraisal Integration Table----------------------- */}
                        {isKpiWeightageIncluded &&
                        isKpiWeightageIncluded === true ? (
                          <>
                            <h5>KPI </h5>
                            <h6>KPI Weightage Value: {KPIWeightage}</h6>
                            <div className="bg-danger">
                              <ReactBootstrap.Table
                                striped
                                bordered
                                hover
                                size="sm"
                                className="bg-danger"
                              >
                                <thead className="text-center">
                                  <tr>
                                    <th>#</th>
                                    <th>KPI</th>
                                    <th nowrap>Start Date</th>
                                    <th>End Date</th>
                                    <th>Department</th>

                                    <th>Progress</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {posts.smartgoals.length === 0 ? (
                                    <tr>
                                      <td colSpan="8" className="text-center">
                                        No data
                                      </td>
                                    </tr>
                                  ) : (
                                    ""
                                  )}
                                  {posts.smartgoals.map((smartgoal, index) => (
                                    <React.Fragment key={index}>
                                      <tr className="w-100">
                                        <td>{index + 1}</td>
                                        <td>{smartgoal.title}</td>
                                        <td>
                                          {formatDate(smartgoal.startdate)}
                                        </td>
                                        <td>{formatDate(smartgoal.enddate)}</td>
                                        <td>{smartgoal.departmentname}</td>
                                        <td hidden>{smartgoal.assigneeids}</td>
                                        <td>
                                          <ProgressBar
                                            variant={getProgressColor(
                                              smartgoal.progress
                                            )}
                                            now={smartgoal.progress}
                                          />
                                        </td>
                                        <td className="col-1">
                                          <input
                                            type="number"
                                            max={KPIWeightage}
                                            value={kpiOptions[index]?.val}
                                            onChange={(e) =>
                                              handleKPIChange(e, smartgoal.id)
                                            }
                                            className="w-75"
                                            disabled
                                          ></input>
                                        </td>
                                        {/* Action buttons */}
                                      </tr>
                                    </React.Fragment>
                                  ))}
                                </tbody>
                              </ReactBootstrap.Table>
                            </div>

                            <h5>Sub KPI</h5>
                            <div className="">
                              <table className="w-100  bg-white">
                                <thead className="text-left">
                                  <tr className="tableheading">
                                    <th>#</th>
                                    <th>Sub KPI</th>
                                    <th>Description</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Progress</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {postsSub.subgoals.map((subgoals, index) => (
                                    <tr className="text-left" key={index}>
                                      <td>{subgoals.id}</td>
                                      <td>{subgoals.title}</td>
                                      <td>{subgoals.description}</td>
                                      <td>{formatDate(subgoals.startdate)}</td>
                                      <td>{formatDate(subgoals.enddate)}</td>
                                      {/* <td>{smartgoal.designationid}</td>
                            <td>{smartgoal.assignees}</td> */}
                                      <td>
                                        <ProgressBar
                                          variant={getProgressColor(
                                            subgoals.progress
                                          )}
                                          now={subgoals.progress}
                                        />
                                      </td>
                                      <td className="col-1">
                                        <input
                                          value={
                                            subkpiOptions &&
                                            subkpiOptions[index]?.val
                                          }
                                          onChange={(e) =>
                                            handleSubKPIChange(e, subgoals.id)
                                          }
                                          type="number"
                                          max={KPIWeightage}
                                          className="w-75"
                                          disabled
                                        ></input>
                                      </td>
                                      {/* Action buttons */}
                                    </tr>
                                  ))}
                                  <tr>
                                    <td
                                      colspan="12"
                                      className="text-end mx-1 text-dark fw-bold"
                                    >
                                      KPI Total Marks
                                      <Field
                                        type="number"
                                        disabled
                                        className="float-end mx-2 "
                                        name="kpitotal"
                                        value={kpiTotal}
                                        readOnly={true}
                                      />{" "}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <br></br>
                          </>
                        ) : null}
                        <br />

                        <table width="100%">
                          <tr>
                            <td className="w-75 text-end   text-dark fw-bold">
                              <b>Overall Total Marks</b>
                            </td>
                            <td>
                              <Field
                                type="number"
                                disabled
                                className="float-end mx-2 "
                                name="appraisalTotal"
                                value={kpiTotal + totVal}
                                readOnly={true}
                              />
                            </td>
                          </tr>
                        </table>

                        <div>
                          <hr></hr>
                          <h5> Overall Rating : {rating} </h5>
                        </div>
                        <hr></hr>

                        <h4>Personal Development Plan</h4>
                        <p>
                          Assessor to comment on any training, educational
                          requirement that would benefit the employee
                        </p>
                        <textarea
                          disabled={trainingComment}
                          rows="5"
                          cols="110"
                          value={trainingComment}
                          onChange={handleTextareaChange}
                          className="w-100"
                        ></textarea>
                      </td>{" "}
                    </tr>
                    <tr>
                      <td
                        colspan="12"
                        className="text-start  text-dark fw-bold"
                      >
                        <h5>ASSESSOR :</h5>
                        <div>
                          {assessorDate === "" || assessorDate === null ? (
                            "Assessor not reviewed"
                          ) : (
                            <React.Fragment>
                              Assessor Name: &nbsp;&nbsp;&nbsp;&nbsp;
                              {hassupervisor === "Yes"
                                ? supervisorName
                                : managerName}
                              <br></br>
                              Assessment Date:&nbsp; {formatDate(assessorDate)}
                              <br></br>
                            </React.Fragment>
                          )}
                        </div>
                        <table className="w-100">
                          <tr className="w-100">
                            <td> </td>
                            <td></td> <td> </td>
                            <td></td>
                          </tr>
                        </table>
                        <textarea
                          disabled={managerComments || assessorComments}
                          rows="5"
                          className="w-100"
                          cols="110"
                        >
                          {assessorComments}
                        </textarea>
                        <h5>Declaration</h5>
                        <input
                          type="checkbox"
                          checked={approval && approval !== null}
                        />{" "}
                        &nbsp; Confirm
                        <br /> I hereby declare that the evaluation is to best
                        of my knowledge, and reflects the fact about employee’s
                        performance and I take responsibility for any misleading
                        information
                        <br />
                        <br />
                      </td>
                    </tr>

                    <tr>
                      <td colspan="12">
                        <h4>APPRAISEE SECTION </h4>
                        <React.Fragment>
                          <b>
                            {employeeApprovalDate === "" ||
                            employeeApprovalDate === null ? (
                              "Appraisee not reviewed"
                            ) : (
                              <div>
                                <b>
                                  Appraisee Name: &nbsp;&nbsp;{" "}
                                  {employee?.FirstName} {employee?.LastName}
                                </b>
                                <br></br>
                                <b>
                                  {" "}
                                  Reviewed Date: &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
                                  {formatDate(employeeApprovalDate)}{" "}
                                </b>
                              </div>
                            )}
                          </b>
                        </React.Fragment>
                        <br></br>
                        <textarea
                          rows="5"
                          cols="110"
                          disabled={
                            (approval && approval === "Employee Accepted") ||
                            approval === "HR Approved" ||
                            approval === "Manager Approved" ||
                            approval === "Approver Approved" ||
                            approval === "Employee Appealed" ||
                            appeal === "Appeal Approved"
                          }
                          value={employeeComments}
                          className="w-100"
                          onChange={(e) => handleHEmployeeomments(e)}
                        >
                          {employeeComments}
                        </textarea>
                        <h5>Declaration</h5>
                        <input
                          type="checkbox"
                          checked={approval && approval !== null}
                        />{" "}
                        &nbsp; Confirm
                        <br /> I hereby declare that the evaluation is best of
                        my knowledge, and reflects the fact about my performance
                        and I accept it.
                        {hassupervisor && hassupervisor === "Yes" && (
                          <React.Fragment>
                            <br />
                            <br />
                            <br />
                            <h4>APPROVER SECTION</h4>
                            <React.Fragment>
                              <b>
                                {approversDate === "" ||
                                approversDate === null ? (
                                  "Approver not reviewed"
                                ) : (
                                  <div>
                                    <b>
                                      Approver Name: &nbsp;&nbsp;{" "}
                                      {employee.ManagerFirstName}{" "}
                                      {employee.ManagerLastName}
                                    </b>
                                    <br></br>
                                    <b>
                                      {" "}
                                      Reviewed Date: &nbsp;&nbsp;&nbsp;&nbsp;
                                      &nbsp;{formatDate(approversDate)}{" "}
                                    </b>
                                  </div>
                                )}
                              </b>
                            </React.Fragment>
                            <br></br>
                            <textarea
                              rows="5"
                              cols="110"
                              // disabled={(approval && (approversDate===null) || (approval==="Approver Approved") || (approval === "HR Approved" || approval === "Manager Submitted" || (hassupervisor === "Yes" && approval === "Employee Accepted")))}
                              disabled={true}
                              value={approverComments || approversComments}
                              className="w-100"
                              onChange={(e) => handleApproveromments(e)}
                            >
                              {approverComments}
                            </textarea>
                            <br />
                            <h5>Declaration </h5>
                            <input
                              type="checkbox"
                              checked={approval && approval !== null}
                            />{" "}
                            &nbsp; Confirm
                            <br /> I hereby declare that the evaluation is best
                            of my knowledge, and reflects the fact about my
                            performance and I accept it.
                          </React.Fragment>
                        )}
                      </td>
                    </tr>
                    {approvalDate ? (
                      <div>
                        <label htmlFor="approvalDate">Status Date:</label>
                        <input
                          type="text"
                          id="approvalDate"
                          value={approvalDate}
                          className=""
                          readOnly // to make it read-only
                        />

                        <div>
                          {" "}
                          <label> Status: {approvalStatus}</label>
                        </div>
                      </div>
                    ) : null}
                    {appeallDate ? (
                      <div>
                        <label htmlFor="applealdate f18">
                          Appeal Requested Date:
                        </label>
                        <input
                          type="text"
                          id="approvalDate"
                          value={appeallDate}
                          className="w-75 p-75 border-0 fw-bold f6"
                          readOnly // to make it read-only
                        />
                        {appealStatus && (
                          <label>
                            <b>Appeal Status:</b> {appealStatus}{" "}
                          </label>
                        )}
                      </div>
                    ) : null}

                    {showHRApproval && (
                      <tr>
                        <td colspan="12">
                          {" "}
                          <div className="col-12">
                            <h4>HR Approval:</h4>
                            <h5>Comments</h5>
                            <textarea
                              rows="5"
                              cols="110"
                              disabled={hrApproved}
                              className="border-1 mt-2 p-3 btn-#8d3523 "
                              value={hrComments}
                              onChange={(e) => handleHRComments(e)}
                            ></textarea>
                            <br />
                            <h5>Declaration </h5>
                            <input
                              type="checkbox"
                              checked={approval && approval !== null}
                            />{" "}
                            &nbsp; Confirm
                            <br /> I hearby declare that is to the best of my
                            knowledge, and reflects the fact about employees
                            performance and I take responsibility for any
                            misleading information.
                          </div>
                        </td>
                      </tr>
                    )}
                    {appeallDate ? (
                      <div>
                        <label htmlFor="applealdate f18">
                          Appeal Requested Date:
                        </label>
                        <input
                          type="text"
                          id="approvalDate"
                          value={appeallDate}
                          className="w-75 p-75 border-0 fw-bold f6"
                          readOnly // to make it read-only
                        />
                        {appealStatus && (
                          <label>
                            HR Appeal Committee Approval Status: {appealStatus}
                          </label>
                        )}
                      </div>
                    ) : null}
                  </tbody>
                </table>

                <div className="col-lg-11 text-end mt-4 pb-3">
                  <Button
                    disabled={
                      (approval && approval === "Approver Rejected") ||
                      approval === "Employee Accepted" ||
                      approval === "HR Approved" ||
                      approval === "Manager Approved" ||
                      approval === "Approver Approved" ||
                      approval === "Employee Appealed" ||
                      approval === "Appeal Approved" ||
                      (approval === "Appeal Committee Approved" &&
                        appealStatus === "Appeal Approved")
                    }
                    className="border-0 mt-2 p-3 btn-#8d3523 "
                    type="submit"
                  >
                    I Agree with My Appraisal
                  </Button>
                  <button
                    disabled={
                      (approval && approval === "Approver Rejected") ||
                      approval === "Employee Accepted" ||
                      approval === "HR Approved" ||
                      approval === "Manager Approved" ||
                      approval === "Approver Approved" ||
                      approval === "Employee Appealed" ||
                      approval === "Appeal Approved" ||
                      (approval === "Appeal Committee Approved" &&
                        appealStatus === "Appeal Approved") ||
                      appealStatus === "Appeal Pending"
                    }
                    type="button"
                    className="btn cancelbtn ml-2"
                    onClick={() => setIsModal2Open(true)}
                  >
                    Appeal Appraisal
                  </button>{" "}
                </div>
              </form>
            )}
          </Formik>

          <Modal show={isModalOpen} onHide={() => setIsModalOpen(false)}>
            <Modal.Header closeButton>
              <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to submit this appraisal?
            </Modal.Body>
            <Modal.Footer>
              <button className="btn btn-primary" onClick={handleConfirm}>
                Confirm
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => setIsModalOpen(false)}
              >
                Cancel
              </button>
            </Modal.Footer>
          </Modal>

          <Modal show={isModal2Open} onHide={() => setIsModal2Open(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Appeal Appraisal</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want Appeal Appraisal?
              <textarea
                name="appealcomments"
                rows={5}
                cols={60}
                onChange={handleAppealChange}
              ></textarea>
            </Modal.Body>
            <Modal.Footer>
              <button className="btn btn-primary" onClick={handleConfirmAppeal}>
                Confirm
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => setIsModal2Open(false)}
              >
                Cancel
              </button>
            </Modal.Footer>
          </Modal>
          <div>
            <ToastContainer position="bottom-end" className="p-3">
              <Toast
                onClose={() => setShowToast(false)}
                show={showToast}
                delay={3000}
                autohide
                className="bg-success text-white"
              >
                <Toast.Header>
                  <span className="me-2">✔️</span> {/* Unicode tick mark */}
                  <strong className="me-auto">Notification</strong>
                </Toast.Header>
                <Toast.Body>Success!, data updated successfully!</Toast.Body>
              </Toast>
            </ToastContainer>
          </div>
        </BasicCard>
      </>
    );
  else {
    return (
      <>
        <Dummylayout />
        <BasicCard>
          <div className="container topmiller ">
            <div className="row ">
              {/* <table style={{ "backgrond-color": "#ffffff" }}>
                <tr>
                  <td className="col-md-1">
                    <label>Step1: Select Year:</label>
                    <select onChange={handleYearChange}>
                      <option>Select Year</option>
                      <option value={currentYear - 1}>{currentYear - 1}</option>
                      <option selected value={currentYear}>
                        {currentYear}
                      </option>
                      <option value={nextYear}>{nextYear}</option>
                    </select>{" "}
                    <label>Step2: Select Period:</label>
                    <select
                      value={selectedPeriod}
                      onChange={handlePeriodChange}
                    >
                      <option value="Select">Select Period</option>
                      <option selected value={"April"}>
                        {" "}
                        April-{selectedYear}
                      </option>
                      <option value={"December"}>
                        {" "}
                        December-{selectedYear}
                      </option>
                    </select>
                  </td>{" "}
                  <td className="col-md-1"></td>
                </tr>
              </table> */}
              <br />
              <hr />
              <h4>My Appraisal</h4>
              <br />
              <br />
              <div className="col-4 ">
                <span className="vfont fs-">Name</span>
                <p className="bfont fs-5 fw-bold">
                  {employee?.FirstName} {employee?.LastName}
                </p>
                <span className="vfont fs">Current Position</span>
                <p className="bfont fs-5 fw-bold">{employee?.designation}</p>
              </div>
              <div className="col-4 ">
                <span className="vfont fs">Employee ID</span>
                <p className="bfont fs-5 fw-bold"> {employee?.employeeid}</p>
                <span className="vfont fs">Grade</span>
                <p className="bfont fs-5 fw-bold">{employee?.gradename}</p>
              </div>
              <div className="col-lg-4 ">
                <img
                  className="float-end mx-5"
                  width="110"
                  alt=""
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAADlAAAA5QGP5Zs8AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAelQTFRF////JG2SQICAJ05iM1VVNXWAM3CFKUtRM3GCJkdRNHCBJkNNJ0BIMnCAM3GAMnCAJDtBNHKAM3GAIzU5IzY7M3GAM3GAKk1WIi8yM3GAISwwM3GAM3GAICgrHyYoHiIjIiUoFBQUFRUUFhUVFhYWFxYWGRkYHBoYHR0eHR4fHh4fHiEiHiEjHx8gIi8zIjE1IjI2Ix4bIyMlIzU6JCAdJCIgJDY8JyIfJ0VNKEZNKSksKSktKTg5LCciLSsnLychL2JvL2VyMGNvMGVzMGZzMGl2MWp4MWt5MWx6Mm17Mm99MyojMzM5M2BpM3B/M3GANXKAN3KAOGx4OjUvO3SAPXSAPjw2Pj45PmVqPz9HP2ZsQF9iQ0VMQ0VNRUVNRUVORkQ9RkZPR1BMSEhRSUlTSkpUU0EzVldfV1dfWU1AXEc3XE9CXn+AXoCAX2l1YGl2Y4KBZk48a1I/b4J+co2iepOVe3uBe5OVgI+Xh46BjGlPjrDHkm5SmXJVnr/Tn7/TocDUo73Npr/PqcPUqq61r4JgsINhsbK1tMjVxZ98xaOCyKF+0aaB1NbY1qmC2ZRk2qB126J23KJ24KyC4qN55Kh65Onu5Oru5qZ75rWV6qh37Kx+7eLc7qx8769/8bGB8vn+87KB9LOCwa3cagAAACF0Uk5TAAcIDQ8YGSwtL0lQfISXmL/ByNXV2uPu7/Lz8/X5/P7+cDzfRAAAAfxJREFUGBllwYk/FFEcAPDfDrsYZtYsu6wZx+t8uSrddEh3aX8Ula5NTCelSESlKBKr0uEs3l/azHvP7O7H9wtJPjVohE0zbARVH2wW0KPoieoBSKdoFqaxNAVS+EMonb+AUsgPnuwIclfuHSJbjl27jFwkGyR/BLkb+wm3/SZyET9wSgiFq0Q6cAa5kAIuDYVbRNh5iRxFQQNHwELhPnGdePNrlGy7iJwVAAAdpeuEbH3w6R9jnwk5iYIO4IuidJy8/MZcf/fuQCnqAxWltsdPmPTiaRtKKgRR6vs6yqS3X/pQCoKBUm/iO5N+JHpRMiCMUmuCeRKtKIXBxA0980ya78ENJpjoGWZsfXV1nbFh9JgQRk/LNFuam1ti0y3oCYOBSe0zzDHTjkkGBDFF/8Ly8kI/pgiCiile/3S8whQq+KIoxZqG1lYWF1fWhppiKEV9ADq6Th3eXV1jT/weG/szYddU7zlyGl06AAQsxLP7qCveNfvh42xXnDp2HTyHaAXAoWGslnId9uTU1KTdQbnaGGrgUkKNVKjvHBwfH+ysp0JjSAHOX0SFuu6H794/6q6jQpEfpNwyKjTbIyN2MxXKcsGTVUK5yrsDA/FKypVkQYrM/Crqanj2vIG6qvIzIV1OQTl13L5DHeUFObBZRl5hcWlFRWlxYV4GeP4Dm5L5s3KTpvYAAAAASUVORK5CYII="
                />
              </div>
            </div>
            <hr></hr>
            <br></br>
            <br></br>
            <h5>
              Your Manager has not completed your appraisal. Please contact your
              manager
            </h5>
            <br></br>
            <br></br>
            <hr></hr>
          </div>
        </BasicCard>
      </>
    );
  }
}
export default ViewMyAppraisal;
